import React from 'react';
import { Link } from 'react-router-dom';
import { CarIcon, TagIcon, CreditCardIcon, BadgeDollarSignIcon, ClipboardListIcon, MessageCircleIcon, ArrowRightIcon } from 'lucide-react';
import { Section, SectionHeading } from '../ui/Section';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../../utils/vehicles';
interface Action {
  icon: typeof CarIcon;
  title: string;
  text: string;
  cta: string;
  to?: string;
  href?: string;
  featured?: boolean;
}
const actions: Action[] = [{
  icon: CarIcon,
  title: 'Catálogo',
  text: 'Explorá nuestros usados seleccionados y 0KM disponibles.',
  cta: 'Ver vehículos',
  to: '/catalogo',
  featured: true
}, {
  icon: TagIcon,
  title: 'Oportunidades',
  text: 'Unidades destacadas con precio especial o financiación conveniente.',
  cta: 'Ver oportunidades',
  to: '/catalogo?oportunidad=1'
}, {
  icon: CreditCardIcon,
  title: 'Financiación 0KM',
  text: 'Consultá planes, cuotas y opciones para acceder a tu próximo 0KM.',
  cta: 'Consultar financiación',
  to: '/financiacion'
}, {
  icon: BadgeDollarSignIcon,
  title: 'Quiero vender mi auto',
  text: 'Nos encargamos de gestionar la venta de tu vehículo de forma profesional.',
  cta: 'Vender mi auto',
  to: '/vender-mi-auto'
}, {
  icon: ClipboardListIcon,
  title: 'Dejar mi consulta',
  text: 'Contanos qué vehículo buscás o qué operación querés realizar.',
  cta: 'Completar formulario',
  to: '/contacto'
}, {
  icon: MessageCircleIcon,
  title: 'Comunicate con un vendedor',
  text: 'Recibí atención personalizada por WhatsApp.',
  cta: 'Hablar ahora',
  href: whatsappLink(GENERAL_WA_MESSAGE)
}];
function ActionBody({
  action
}: {
  action: Action;
}) {
  const Icon = action.icon;
  return <>
      <span className={`inline-grid place-items-center rounded-xl ${action.featured ? 'h-12 w-12 bg-neon text-white' : 'h-11 w-11 bg-neon/12 text-neon'}`} data-id="element-366" data-mp="16uhxooukgq4y">
        <Icon className={action.featured ? 'h-6 w-6' : 'h-5 w-5'} aria-hidden="true" data-id="element-367" data-mp="37wfzho1o2hax" />
      </span>
      <h3 className={`mt-5 font-bold text-white ${action.featured ? 'text-2xl md:text-[28px]' : 'text-lg'}`} data-id="element-368" data-mp="32xwhfyq71pnu">
        {action.title}
      </h3>
      <p className={`mt-2 leading-relaxed text-mist ${action.featured ? 'max-w-md text-[15px]' : 'text-sm'}`} data-id="element-369" data-mp="3cuhn8ma1f4sq">
        {action.text}
      </p>
      <span className="mt-auto inline-flex items-center gap-1.5 pt-5 text-sm font-semibold text-neon-soft" data-id="element-370" data-mp="3mkubopkz3i45">
        {action.cta}
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-371" data-mp="4dwft9x20jrq" />
      </span>
    </>;
}
export function QuickActions() {
  return <Section id="accesos" className="bg-surface" data-id="element-372" data-mp="3vj60cm2a45ty">
      <SectionHeading title="¿Qué querés hacer hoy?" lead="Elegí el camino más directo: comprar, vender, financiar o hablar con un asesor." data-id="element-373" data-mp="265j433pka0ki" />

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-374" data-mp="gp70alqzs358">
        {actions.map(a => {
        const className = `group flex flex-col rounded-2xl border border-line bg-surface2/50 p-6 transition-[border-color,transform,background-color] duration-200 ease-smooth hover:-translate-y-0.5 hover:border-neon/50 hover:bg-surface2 ${a.featured ? 'md:col-span-2 md:p-8' : ''}`;
        return a.href ? <a key={a.title} href={a.href} target="_blank" rel="noopener noreferrer" className={className} data-id="element-375" data-mp="3u3ttiqssd1le">
              <ActionBody action={a} data-id="element-376" data-mp="3k6p8wvel9e6p" />
            </a> : <Link key={a.title} to={a.to as string} className={className} data-id="element-377" data-mp="3p50id50z1moe">
              <ActionBody action={a} data-id="element-378" data-mp="3p735nhaqp1pf" />
            </Link>;
      })}
      </div>
    </Section>;
}